(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var vnsComponent = {
  name: 'vue-number-scroll',
  props: {
    speed: {
      type: Number,
      required: false,
      default: 50
    },
    times: {
      type: Number,
      required: false,
      default: 10
    },
    start: {
      type: Number,
      required: false,
      default: 0
    },
    end: {
      type: Number,
      required: false,
      default: 0
    },
    format: {
      type: Function,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      showNumber: 0
    };
  },
  render: function render(h) {
    return h('span', this.format ? this.format(this.showNumber) : this.showNumber);
  },

  // template: '<span><template v-if="format">{{ format(showNumber) }}</template><template v-else>{{ showNumber }}</template></span>',
  created: function created() {
    this.showNumber = this.start;
  },
  mounted: function mounted() {
    this.JNumberScroll({
      speed: this.speed, // 变换速度
      times: this.times, // 变换次数
      start: this.start, // 起始数量
      end: this.end // 到达数量
    });
  },

  watch: {
    end: function end(newValue, oldValue) {
      this.JNumberScroll({
        speed: this.speed, // 变换速度
        times: this.times, // 变换次数
        start: oldValue, // 起始数量
        end: newValue // 到达数量
      });
    }
  },
  methods: {
    JNumberScroll: function JNumberScroll(params) {

      // 分割后要遍历显示的数组
      var splitArr = [];

      // end 和 start之间的间隔
      var gap = Math.abs(params.end - params.start);
      // 判断是增加还是减少
      var add = params.end - params.start > 0;

      // 叠加数
      var splitNum = gap / params.times;
      // end字符串，用于判断变化过程是否显示小数
      var endStr = String(params.end);

      // end是否为浮点数，用途就是展示效果是否显示小数
      var isFloat = endStr.indexOf('.') !== -1;

      // 整数叠加数小于1的可能，间隔最小就为1，次数也为end-start的绝对值
      !isFloat && splitNum < 1 && (splitNum = 1) && (params.times = gap);

      for (var i = 0; i < params.times; i++) {
        var tempNum = add ? params.start + splitNum * i : params.start - splitNum * i;

        // 小数的位数
        var decimalNum = 0;
        // 如果是浮点数，就获取小数的位数
        isFloat && (decimalNum = endStr.length - endStr.indexOf('.') - 1);

        // 最后是否保留小数位
        splitArr.push(isFloat ? parseInt(tempNum * Math.pow(10, decimalNum)) / Math.pow(10, decimalNum) : parseInt(tempNum));
      }
      // 如果增加，并且数组最后一位比end小，则push最后一位；如果减少，并且数组最后一位比end大，则push最后一位
      (add && splitArr[splitArr.length - 1] < params.end || !add && splitArr[splitArr.length - 1] > params.end) && splitArr.push(params.end);

      var _index = 0;

      var _this = this;
      // 定时显示
      var intervalId = setInterval(function () {

        if (_index < splitArr.length) _this.showNumber = splitArr[_index++];else {
          clearInterval(intervalId);
        }
      }, params.speed);
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("vns", vnsComponent);
}

/* harmony default export */ __webpack_exports__["default"] = (vnsComponent);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-number-scroll.js